import * as React from 'react';
import { useEffect, useState } from 'react';
import styles from './OwnershipStructure.module.scss';
import OwnershipStructureProps from './OwnershipStructure.types';
import ParsedText from '../../atoms/ParsedText';
import IncrementalInput from '../../molecules/IncrementalInput';

const InputNames = {
  FIRST: 'youOwn',
  SECOND: 'theyOwn',
};

const MAX_VALUE = 100;

const OwnershipStructure = ({
  firstInputTitle,
  firstInputDescription,
  firstInputInitialValue,
  secondInputTitle,
  secondInputDescription,
  secondInputInitialValue,
  onChange,
  dataPointer = '',
  dataCy = 'ownershipStructure',
  invalid,
}: OwnershipStructureProps) => {
  const [firstInputValue, setFirstInputValue] = useState<number>(firstInputInitialValue);
  const [secondInputValue, setSecondInputValue] = useState<number>(secondInputInitialValue);

  const IncrementalComponent = ({ title, description, inputProps }) => (
    <div className={styles.incrementContainer}>
      <ParsedText htmlString={title} />
      <ParsedText htmlString={description} />
      <IncrementalInput {...inputProps} />
    </div>
  );

  const FirstIncrementalInput = ({ inputProps }) =>
    IncrementalComponent({
      inputProps,
      title: firstInputTitle,
      description: firstInputDescription,
    });

  const SecondIncrementalInput = ({ inputProps }) =>
    IncrementalComponent({
      inputProps,
      title: secondInputTitle,
      description: secondInputDescription,
    });

  useEffect(() => {
    const total = firstInputValue + secondInputValue;
    if (total === MAX_VALUE) {
      onChange({
        dataPointer,
        value: {
          applicant_0: {
            ownershipPercentage: firstInputValue,
          },
          applicant_1: {
            ownershipPercentage: secondInputValue,
          },
        },
      });
    }
  }, [firstInputValue, secondInputValue]);

  const handleIncrementAndDecrement = (event) => {
    if (event.name === InputNames.FIRST) {
      setSecondInputValue(MAX_VALUE - event.value);
    } else if (event.name === InputNames.SECOND) {
      setFirstInputValue(MAX_VALUE - event.value);
    }
  };

  const firstInputProps = {
    onChange: handleIncrementAndDecrement,
    name: InputNames.FIRST,
    value: firstInputInitialValue,
    max: MAX_VALUE,
    dataCy: `${dataCy}FirstInput`,
  };

  const secondInputProps = {
    onChange: handleIncrementAndDecrement,
    name: InputNames.SECOND,
    value: secondInputInitialValue,
    max: MAX_VALUE,
    dataCy: `${dataCy}SecondInput`,
  };

  const firstIncrementalInput = FirstIncrementalInput({
    inputProps: {
      ...firstInputProps,
      value: firstInputValue || firstInputInitialValue,
      invalid,
    },
  });

  const secondIncrementalInput = SecondIncrementalInput({
    inputProps: {
      ...secondInputProps,
      value: secondInputValue || secondInputInitialValue,
      invalid,
    },
  });

  return (
    <div>
      {firstIncrementalInput}
      {secondIncrementalInput}
    </div>
  );
};

export default OwnershipStructure;
